export default __webpack_public_path__ + "static/media/reverse.d9e77d3f.svg";